export enum AccessTokenState {
    Unknown                 = 0,
    Good                    = 1,
    ExpiredRefreshing       = 2,
    ExpiredErrorTemp        = 3,
    ExpiredErrorTempNetwork = 4,
    ExpiredErrorPermanent   = 5,
}
